import { State } from '../../types';

export const illinois: State = {
  name: 'Illinois',
  abbreviation: 'IL',
  terms: [
    {
      word: 'Benld',
      phonetic: 'ben-ELD',
      // audioUrl: '/audio/benld.mp3',
      description: 'A city in Macoupin County, pronounced "ben-ELD," not "BEN-eld." Named after its founder, Benjamin L. Dorsey.'
    },
    {
      word: 'Cairo',
      phonetic: 'KAY-roh',
      // audioUrl: '/audio/cairo.mp3',
      description: 'A city in Alexander County, pronounced "KAY-roh," not like the Egyptian capital "KAI-roh."'
    },
    {
      word: 'Chautauqua',
      phonetic: 'shuh-TAWK-wuh',
      // audioUrl: '/audio/chautauqua.mp3',
      description: 'A village located between Elsah and Grafton in Jersey County.'
    },
    {
      word: 'Des Plaines',
      phonetic: 'dess-PLAINZ',
      // audioUrl: '/audio/desplaines.mp3',
      description: 'City in northeastern Illinois'
    },
    {
      word: 'Illinois',
      phonetic: 'ill-ih-NOY',
      // audioUrl: '/audio/illinois.mp3',
      description: 'State name pronunciation'
    },
    {
      word: 'Loogootee',
      phonetic: 'LOH-guh-TEE',
      // audioUrl: '/audio/loogootee.mp3',
      description: 'An unincorporated community near Effingham.'
    },
    {
      word: 'Marseilles',
      phonetic: 'mar-SALES',
      // audioUrl: '/audio/marseilles.mp3',
      description: 'A city in LaSalle County, pronounced "mar-SALES," not like the French city "mar-SAY."'
    },
    {
      word: 'New Berlin',
      phonetic: 'BER-lin',
      // audioUrl: '/audio/new_berlin.mp3',
      description: 'A village in Sangamon County, pronounced "BER-lin," not like the German capital "ber-LEEN."'
    },
    {
      word: 'San Jose',
      phonetic: 'san-JOE-s',
      // audioUrl: '/audio/san_jose_il.mp3',
      description: 'A village in Logan County.'
    },
    {
      word: 'Teheran',
      phonetic: 'tuh-HAIR-uhn',
      // audioUrl: '/audio/teheran.mp3',
      description: 'An unincorporated community in Mason County, pronounced "tuh-HAIR-uhn," not like the Iranian capital "teh-RAHN."'
    },
    {
      word: "The L",
      phonetic: "THE ELL",
      description: "Short for the elevated train system central to Chicago’s public transit.",
    },
    {
      word: 'Vienna',
      phonetic: 'VY-en-uh',
      // audioUrl: '/audio/vienna.mp3',
      description: 'A city in Johnson County, pronounced "VY-en-uh," not like the Austrian capital "vee-EN-nuh."'
    },
    {
      word: 'Waukegan',
      phonetic: 'waw-KEE-guhn',
      // audioUrl: '/audio/waukegan.mp3',
      description: 'A city just north of Chicago.'
    },
    {
      word: 'Wataga',
      phonetic: 'wah-TAH-guh',
      // audioUrl: '/audio/wataga.mp3',
      description: 'A village in Knox County near Galesburg.'
    }
  ]
};